import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { getSecondarySite } from '~/shared/utils/useSecondarySite';
import { useAccountActions } from '~/techstyle-shared/react-accounts';

import useAccountLinks from '../../utils/useAccountLinks';
import LogOutButton from '../LogOutButton';
import NavLink from '../NavLink';

const Wrapper = styled.div`
  margin: 0 auto;
`;

const List = styled.ul`
  ${({ theme }) => theme.lists.bare};
`;

const ListItem = styled.li`
  font-size: 16px;
  font-weight: normal;
`;

const accountLinkStyle = css`
  font-weight: inherit;
  padding: 0.5em;
`;

const StyledNavLink = styled(NavLink)`
  ${accountLinkStyle}
  display: block;
`;

const StyledLogoutButton = styled(LogOutButton)`
  ${accountLinkStyle}
`;

export default function AccountLinks({
  isNavToolbar = false,
  setVipTreatmentDetails,
  vipTreatmentDetails,
  ...props
}) {
  const { data } = useAccountLinks();
  const { logOut } = useAccountActions();
  const router = useRouter();
  const secondarySite = getSecondarySite(router.asPath);
  const redirectUrl = secondarySite ? `/${secondarySite}` : '/';

  if (!data || !data.navItems) {
    return null;
  }

  return (
    <Wrapper {...props}>
      <List>
        {data.navItems.map((item) => (
          <ListItem key={item.id}>
            <StyledNavLink {...item} showFlags={false} whiteSpace="nowrap" />
          </ListItem>
        ))}
        {isNavToolbar && (
          <ListItem>
            <StyledLogoutButton onClick={() => logOut(redirectUrl)} />
          </ListItem>
        )}
      </List>
    </Wrapper>
  );
}

AccountLinks.propTypes = {
  /**
   * If the links are being displayed from the upper right dropdown
   */
  isNavToolbar: PropTypes.bool,
  setVipTreatmentDetails: PropTypes.func,
  vipTreatmentDetails: PropTypes.bool,
};

AccountLinks.Wrapper = Wrapper;
AccountLinks.List = List;
AccountLinks.ListItem = ListItem;
AccountLinks.Link = StyledNavLink;
AccountLinks.LogOutButton = LogOutButton;
